export enum EAuthFormType {
  Auth = 'Auth',
  Lander = 'Lander'
}

export enum EResendCodeUsage {
  Profile = 'profile',
  Chat = 'chat',
  PasswordReset = 'passwordReset'
}

export enum ELocalStorageKey {
  VerifySent = 'verifySent',
  CognitoAccessToken = 'cognitoAccessToken',
  CountdownVerificationStartTime = 'countdownVerificationStartTime',
  RedirectUrl = 'redirectUrl',
  ProfileOpened = 'profileOpened',
  ProfileCompleted = 'profileCompleted',
  User = 'user',
  UserId = 'userId',
  AccessToken = 'accessToken',
  CreatorInfo = 'creatorInfo',
  BackUrl = 'backUrl',
  LastActiveConversationId = 'lastActiveConversationId',
  RecentlyGeneratedImages = 'recentlyGeneratedImages'
}

export enum ECarouselNavigation {
  Previous = 'previous',
  Next = 'next'
}

export enum EPlayButtonUsage {
  DiscoverCard = 'discoverCard',
  ChatMessage = 'chatMessage'
}

export enum EPromptUsage {
  Chat = 'chat',
  ImageGeneration = 'imageGeneration'
}

export enum EMediaLightboxUsage {
  MasonryGallery = 'masonryGallery',
  ImageGeneration = 'imageGeneration'
}

export enum EContentRatingType {
  SFW = 'sfw',
  NSFW = 'nsfw'
}

export enum ETooltipPlacement {
  Top = 'top',
  Bottom = 'bottom'
}
